import request from '../utils/request.js'
//获取商品评论
export function buyerShowList(data) {
  return request({
    url: process.env.API + "/data/order/fcomments",
    method: 'get',
    params: data,
  })
}



// WEBPACK FOOTER //
// ./src/api/buyerShow.js